/*
 * @Author: zjg
 * @Date: 2020-04-14 15:14:33
 * @LastEditTime: 2020-04-29 17:48:49
 * @Deccription: 目前为全局toast的信息，后期用组件注册时，删除此文件
 */
import TYPES from '../types'

function setDefault(state, d) {
  if (d instanceof Object && d.content instanceof Object) {
    state.toastInfo.switch = d.switch || true
    state.toastInfo.content.tipsType = d.content.tipsType || 'success'
    state.toastInfo.content.info = d.content.info || ''
    return
  }
  if (d instanceof Object) {
    state.toastInfo.switch = d.switch || true
    state.toastInfo.content.tipsType = d.tipsType || 'success'
    state.toastInfo.content.info = d.info || ''
    return
  }
  state.toastInfo.switch = true
  state.toastInfo.content.info = d
}
export const commonSate = {
  toastInfo: {
    switch: false,
    content: {
      info: '',
      tipsType: 'success',
    },
  },
}
export const commonMutations = {
  [TYPES.GET_TOAST_INFO](state, data) {
    setDefault(state, data)
  },
}
